import amplitude from "amplitude-js";
import LocalStorageFunc from "../helpers/localStorageFunc";
import Utility from "../helpers/utility";
import StorageKeys from "./storageKeys";
import PageNames from "./pageNames";
import ApiKeys from "./apiKeys";
import { EndPoints } from "./apiEndpoints";

const amplitudeApiKey = EndPoints?.AMPLITUDE_API_KEY || "";
const amplitudeInstanceName = EndPoints?.AMPLITUDE_INSTANCE_NAME || "";

const amplitudeConfigObj = {
  saveEvents: true,
  includeUtm: true,
  includeReferrer: true,
  saveParamsReferrerOncePerSession: false,
  unsetParamsReferrerOnNewSession: true,
};

const getAmplitudeInstance = () => amplitude?.getInstance(amplitudeInstanceName);

getAmplitudeInstance().init(amplitudeApiKey, null, amplitudeConfigObj);

const ampUserProperties = function () {
  let queryParams = Utility.getQueryFromUrl();

  const sourceChannel = queryParams["utm_source"] || "direct";
  const campaign = queryParams["utm_campaign"];
  const userId = LocalStorageFunc.getUserId();
  const { coords = {} } = LocalStorageFunc.getCoordsFromRecentLocation() || {};
  const latitude = coords?.latitude;
  const longitude = coords?.longitude;
  const pincode =
    LocalStorageFunc.getLastLocationNewOrLastLocationNewForIp()?.[0]?.recent
      ?.addressComponent?.postalCode;
  const orderType = LocalStorageFunc.getDeliveryType();
  const storeId = LocalStorageFunc.storeId();

  const userAgent = window?.navigator?.userAgent || "";
  let deviceType = Utility.getDeviceType(userAgent);

  let landingPage = LocalStorageFunc.getSessionStorageKey(
    StorageKeys.LANDING_PAGE,
    ""
  );
  if (!landingPage) {
    landingPage = PageNames.getPageNameFromPathName();

    LocalStorageFunc.setSessionStorageKey(
      StorageKeys.LANDING_PAGE,
      landingPage
    );
  }

  let isLogin = LocalStorageFunc.isLoggedIn() ? 1 : 0;

  return {
    userId,
    sourceChannel,
    campaign,
    latitude,
    longitude,
    pincode,
    orderType,
    storeId,
    userAgent,
    deviceType,
    landingPage,
    isLogin,
  };
};

export { ampUserProperties, getAmplitudeInstance };
